import $ from 'jquery'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/manipulation';
import 'swiper/css/grid';
import 'swiper/css/free-mode';

import Swiper from 'swiper';
import { Navigation, Manipulation, FreeMode, Grid } from 'swiper/modules';

import { configBookCard } from './module_book_card'
import { configArticleCard } from './module_article_card'

import { updateCardLazyLoad } from './module_lazyload';

const needMoreCarouselItems = function(container) {
    if (container.data('reachEnd') === 1) return false
    const items = container.find(".swiper-slide").length
    const limit = container.data('limit')
    const offset = container.data('offset')
    const remainder = offset % limit
    if (remainder === 0 && items === offset + limit) return true
    return false
}

const loadCards = function (searchEndPoint, content, limit, offset, success, done){
    $.ajax({
      method: "POST",
      url: searchEndPoint,
      data: {
          contenttype: content,
          limit: limit,
          offset: offset
      },
      dataType: 'json',
      success: function(data){
        success(data)
      },
      error: function(err){
        // console.log("Got some error: ", err)
      }
    }).done(function () {
        done();
    })
}

const loadCardDone = function(container) {
    return function(){
        container.data('loading', 0)
    }
}
  
const updateCards = function(container) {
    return function (data) {
        if (data.cards.length === 0){
            // Using the data() method to update data does not affect attributes in the DOM!
            container.data('reachEnd', 1)
            return
        }
        const sw = container.get(0).swiper
        sw.appendSlide(data.cards)
        const oldOffset = container.data('offset')
        const newOffset = oldOffset + data.cards.length
        container.data('offset', newOffset)
        if (data.cards.length < container.data('limit')){
            container.data('reachEnd', 1)
        }
        
        updateCardLazyLoad()

        const cardType = container.data('cardtype')
        if (cardType == 'book'){
            configBookCard()
        }else if(cardType == 'article'){
            configArticleCard()
        }else if(cardType == 'podcastCardType'){
            // console.log("podcastCardType")
        }else if(cardType == 'skillCardType'){
            // console.log("skillCardType")
        }
    }
}

// Activate pagination item load with:
// * provide a searchCardsEndpoint
// * set on swiper container some html data attribute: contentType, limit, offset, reachEnd
// this will fire a POST call to the given searchCardsEndpoint with contentType, limit and offset data
export function defaultCarouselSetupNew (containerClass, outClass, mobileSlides, tabletSlides, desktopSlides, desktopBigSlides, searchCardsEndpoint) {
    const outSelector = "."+outClass;
    const containerSelector = "."+containerClass
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation, FreeMode],
        slidesPerView: mobileSlides,
        slidesPerGroup: 1,
        spaceBetween: 16,
        freeMode: {
            enabled: true,
        },
        watchSlidesProgress: true,
        navigation: {
            enabled: false,
        },
        allowTouchMove: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: tabletSlides,
                slidesPerGroup: 1,
                allowTouchMove: true,
                spaceBetween: 16,
                freeMode: {
                    enabled: true,
                },
                navigation: {
                    enabled: false,
                },
            },
            992: {
                slidesPerView: desktopSlides,
                slidesPerGroup: desktopSlides,
                allowTouchMove: false,
                navigation: {
                    enabled: true,
                    nextEl: outSelector + ' .swiper-button-next',
                    prevEl: outSelector + ' .swiper-button-prev',
                },
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
            },
            1199: {
                allowTouchMove: false,
                slidesPerView: desktopBigSlides,
                slidesPerGroup: desktopBigSlides,
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
                navigation: {
                    enabled: true,
                    nextEl: outSelector + ' .swiper-button-next',
                    prevEl: outSelector + ' .swiper-button-prev',
                },
            }
        },
        on: {
            init: function (sw) {
                swiper_cont.addClass("ready")
                swiper_cont.addClass("mobile-ready")
            },
        }
    });

    window.swiper = swiper

    // paginated carousel init
    if (!searchCardsEndpoint || !swiper_cont.data('contenttype')) return swiper
    if (swiper_cont.length == 0) return

    swiper.on('activeIndexChange', function(){
        if (swiper_cont.data('loading') === 1) return
        const limit = swiper_cont.data('limit');
        const contType = swiper_cont.data('contenttype')

        let slidePerView = swiper.params.slidesPerView
        if (slidePerView === "auto") {
            // swiper-slide-visible class is added with watchSlidesProgress=true
            slidePerView = $(".swiper-slide-visible").length
        }

        // max index of card in view
        const displayedMaxItem = (swiper.activeIndex + (Math.round(slidePerView)))
        const actualOffset = swiper_cont.data('offset')
        
        const threshold = actualOffset + limit
        // comparePlus define when starts to load more items
        const comparePlus = 2
        const currentCompare = displayedMaxItem + comparePlus

        if (currentCompare >= threshold) {
            const need = needMoreCarouselItems(swiper_cont)
            if (need) {
                swiper_cont.data('loading', 1)
                loadCards(
                    searchCardsEndpoint, 
                    contType, 
                    limit, 
                    actualOffset + limit, 
                    updateCards(swiper_cont), 
                    loadCardDone(swiper_cont)
                )
            }
        }
    })
    return swiper
}

export function defaultCarouselSetupTwoRow (containerClass, outClass, mobileSlides, tabletSlides, desktopSlides, searchCardsEndpoint) {
    const outSelector = "."+outClass;
    const containerSelector = "."+containerClass
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation, FreeMode, Grid],
        slidesPerView: mobileSlides,
        spaceBetween: 16,
        freeMode: {
            enabled: true,
        },
        watchSlidesProgress: true,
        navigation: {
            enabled: false,
        },
        allowTouchMove: true,
        grid: {
            rows: 2,
        },
        updateOnWindowResize: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: tabletSlides,
                allowTouchMove: true,
                freeMode: {
                    enabled: true,
                },
                spaceBetween: 16,
                navigation: {
                    enabled: false,
                },
                grid: {
                    rows: 2,
                },
            },
            992: {
                slidesPerView: desktopSlides,
                slidesPerGroup: desktopSlides,
                allowTouchMove: false,
                spaceBetween: 24,
                freeMode: {
                    enabled: false,
                },
                grid: {
                    rows: 2,
                },
                navigation: {
                    enabled: true,
                    nextEl: outSelector + ' .swiper-button-next',
                    prevEl: outSelector + ' .swiper-button-prev',
                },
            },
        },
        on: {
            init: function (sw) {
                swiper_cont.addClass("ready")
                swiper_cont.addClass("mobile-ready")
            },
        }
    });

    window.swiper = swiper

    // paginated carousel init
    if (!searchCardsEndpoint || !swiper_cont.data('contenttype')) return
    if (swiper_cont.length == 0) return

    swiper.on('activeIndexChange', function(){
        if (swiper_cont.data('loading') === 1) return
        const limit = swiper_cont.data('limit');
        const contType = swiper_cont.data('contenttype')

        let slidePerView = swiper.params.slidesPerView
        if (slidePerView === "auto") {
            // swiper-slide-visible class is added with watchSlidesProgress=true
            slidePerView = $(".swiper-slide-visible").length
        }

        // max index of card in view
        const displayedMaxItem = (swiper.activeIndex * 2 + (Math.round(slidePerView)) * 2)
        const actualOffset = swiper_cont.data('offset')
        
        const threshold = actualOffset + limit
        // comparePlus define when starts to load more items
        const comparePlus = 2
        const currentCompare = displayedMaxItem + comparePlus

        if (currentCompare >= threshold) {
            const need = needMoreCarouselItems(swiper_cont)
            if (need) {
                swiper_cont.data('loading', 1)
                loadCards(
                    searchCardsEndpoint, 
                    contType, 
                    limit, 
                    actualOffset + limit, 
                    updateCards(swiper_cont), 
                    loadCardDone(swiper_cont)
                )
            }
        }
    })
}

export function coachCarouselSetupTwoRow (containerSelector, outSelector, mobileSlides, tabletSlides, desktopSlides) {
    const swiper_cont = $(containerSelector);
    if (swiper_cont.length === 0) return

    var swiper = new Swiper(containerSelector, {
        modules: [Navigation, Manipulation, FreeMode, Grid],
        slidesPerView: mobileSlides,
        spaceBetween: 16,
        freeMode: {
            enabled: true,
        },
        navigation: {
            enabled: false,
        },
        watchSlidesProgress: true,
        allowTouchMove: true,
        grid: {
            rows: 2,
        },
        updateOnWindowResize: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: tabletSlides,
                allowTouchMove: true,
                freeMode: {
                    enabled: true,
                },
                grid: {
                    rows: 2,
                },
            },
            992: {
                slidesPerView: desktopSlides,
                // slidesPerGroup: desktopSlides,
                allowTouchMove: false,
                navigation: {
                    enabled: true,
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                freeMode: {
                    enabled: false,
                },
                grid: {
                    rows: 2,
                },
            },
        },
        on: {
            init: function (sw) {
                swiper_cont.addClass("ready")
                swiper_cont.addClass("mobile-ready")
            },
        }
    });

    window.swiper = swiper
}